/* Keep the hero clear at page load, then reveal the mobile bottom navigation
   as soon as the visitor starts scrolling the homepage. */
(function () {
  'use strict';

  var MOBILE_MAX = 767;
  var nav = document.getElementById('stickymenu_bottom_mobile');
  var SCROLL_TRIGGER = 8;

  if (!nav) return;

  function isMobile() {
    return window.innerWidth <= MOBILE_MAX;
  }

  function measureNav() {
    document.documentElement.style.setProperty('--home-mobile-nav-height', nav.offsetHeight + 'px');
  }

  function show() {
    if (!isMobile()) return;
    measureNav();
    document.body.classList.add('mobile-bottom-nav-visible');
  }

  function hide() {
    document.body.classList.remove('mobile-bottom-nav-visible');
  }

  function update() {
    if (!isMobile()) {
      hide();
      return;
    }
    if (window.scrollY > SCROLL_TRIGGER) show();
    else hide();
  }

  function start() {
    measureNav();

    window.addEventListener('scroll', update, { passive: true });
    update();

    window.addEventListener('resize', function () {
      measureNav();
      update();
    });
  }

  start();
}());
